import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <h6 style={{ color: "white" }}>AARUUSH 2020 (Online edition)</h6>
    </footer>
  );
};

export default Footer;
